<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12" md="9" mx-auto>
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="px-0 py-2">
            <v-layout row wrap>
              <v-flex xs12>
                <v-combobox
                v-model="curComm"
                label="Community"
                :items="commList"
                item-text="comm_name"
                item-value="comm_id"
                placeholder="Choose"
                filled
                clearable
                @input="curComm ? loadShifts(curComm) : ''"
                ></v-combobox>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="px-0 py-3" v-if="curComm && curComm.comm_id">
            <v-data-table
            :headers="$vuetify.breakpoint.smAndUp?shiftHeadSm:shiftHead"
            :items="shifts"
            hide-default-footer
            class="elevation-2"
            sort-by="shift_abbr"
            :mobile-breakpoint="0"
            >
            <template slot="item" slot-scope="props">
              <tr @click="prepareUpdateShift(props.item)">
                <td>{{ props.item.shift_abbr }}</td>
                <td>{{ props.item.start_time }}</td>
                <td>{{ props.item.end_time }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.shift_hours }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.break_start }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.break_end }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <!-- create / update / delete roles -->
      <v-container v-if="lAction === 'create-shift' || lAction === 'update-shift'" class="pa-0" fluid full-height>
        <v-layout row wrap>
          <v-flex xs12>
            <v-form ref="sForm" @submit.prevent="saveChangesShift(lAction)">
              <v-card flat>
                <v-flex xs12 mx-auto>
                  <v-card-title class="title pb-0">
                    {{lAction === 'create-shift' ? 'Create' : 'Update' }} Shift
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                        label="Shift Abbreviation"
                        v-model="lShift.shift_abbr"
                        :rules="[rules.required]"
                        hide-details
                        maxlength="15"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-dialog
                        ref="shiftStart"
                        persistent
                        v-model="dlgShiftStart"
                        max-width="290px"
                        :return-value.sync="lShift.start_time"
                        >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                          slot="activator"
                          label="Starts at"
                          v-model="lShift.start_time"
                          append-icon="mdi-clock"
                          clearable
                          readonly
                          v-on="on"
                          hide-details
                          :rules="[rules.required]"
                          ></v-text-field>
                        </template>
                        <v-time-picker v-model="lShift.start_time"
                        ampm-in-title>
                        <div class="flex-grow-1"></div>
                        <v-btn  @click="dlgShiftStart = false">Cancel</v-btn>
                        <v-btn  color="accent" @click="$refs.shiftStart.save(lShift.start_time)">OK</v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs6>
                    <v-dialog
                    ref="shiftEnd"
                    persistent
                    v-model="dlgShiftEnd"
                    max-width="290px"
                    :return-value.sync="lShift.end_time"
                    >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                      slot="activator"
                      label="Ends at"
                      v-model="lShift.end_time"
                      append-icon="mdi-clock"
                      clearable
                      readonly
                      v-on="on"
                      hide-details
                      :rules="[rules.required]"
                      ></v-text-field>
                    </template>
                    <v-time-picker v-model="lShift.end_time" ampm-in-title>
                      <div class="flex-grow-1"></div>
                      <v-btn  @click="dlgShiftEnd = false">Cancel</v-btn>
                      <v-btn  color="accent" @click="$refs.shiftEnd.save(lShift.end_time)">OK</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  label="Shift Hours"
                  v-model="lShift.shift_hours"
                  :rules="[rules.required]"
                  hide-details
                  maxlength="5"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <div class="subheader mt-3 primary--text">
                    Additional information (optional)
                  </div>
                </v-flex>
                <v-flex xs6>
                  <v-dialog
                  ref="breakStart"
                  persistent
                  v-model="dlgBreakStart"
                  max-width="290px"
                  :return-value.sync="lShift.break_start"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    slot="activator"
                    label="Break from"
                    v-model="lShift.break_start"
                    append-icon="mdi-clock"
                    clearable
                    readonly
                    v-on="on"
                    hide-details
                    ></v-text-field>
                  </template>
                  <v-time-picker v-model="lShift.break_start" ampm-in-title>
                    <div class="flex-grow-1"></div>
                    <v-btn  @click="dlgBreakStart = false">Cancel</v-btn>
                    <v-btn  color="accent" @click="$refs.breakStart.save(lShift.break_start)">OK</v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs6>
                <v-dialog
                ref="breakEnd"
                persistent
                v-model="dlgBreakEnd"
                max-width="290px"
                :return-value.sync="lShift.break_end"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                  slot="activator"
                  label="Break till"
                  v-model="lShift.break_end"
                  append-icon="mdi-clock"
                  clearable
                  readonly
                  v-on="on"
                  hide-details
                  ></v-text-field>
                </template>
                <v-time-picker v-model="lShift.break_end" ampm-in-title>
                  <div class="flex-grow-1"></div>
                  <v-btn  @click="dlgBreakEnd = false">Cancel</v-btn>
                  <v-btn  color="accent" @click="$refs.breakEnd.save(lShift.break_end)">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-btn v-if="lAction === 'update-shift'"  @click.stop="deleteShift">Delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn  @click.stop="cancelChanges">Cancel</v-btn>
          <v-btn  type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
        </v-card-actions>
      </v-flex>
    </v-card>
  </v-form>
</v-flex>
</v-layout>
</v-container>

<v-btn v-if ="lAction === 'view'"
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
dark fab fixed color="accent"
@click.native="prepareCreate">
<v-icon>mdi-plus</v-icon>
</v-btn>

</v-col>
</v-row>
<!-- snack bar for error reporting -->
<v-snackbar :color="sbarCol" v-model="sbar" :timeout="3000" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      config: config,
      handy: handy,
      rules: handy.rules,
      beingSaved: false,
      lAction: '',
      commList: [],
      curComm: '',
      shifts: [],
      shiftHead: [
        { text: 'Shift', value: 'shift_abbr' },
        { text: 'Starts At', value: 'start_time' },
        { text: 'Ends At', value: 'end_time' }
      ],
      shiftHeadSm: [
        { text: 'Shift', value: 'shift_abbr' },
        { text: 'Starts At', value: 'start_time' },
        { text: 'Ends At', value: 'end_time' },
        { text: 'Shift Hours', value: 'shift_hours' },
        { text: 'Break From', value: 'break_start' },
        { text: 'Break Till', value: 'break_end' }
      ],
      lShift: '',
      dlgShiftStart: false,
      dlgShiftEnd: false,
      dlgBreakStart: false,
      dlgBreakEnd: false
    }
  },
  created () {
    this.loadComm()
  },
  mounted () {
    this.lAction = 'view'
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadComm () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getCommunityByVendorId/', qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadShifts () {
      var qry = {
        params: {
          comm_id: this.curComm.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getShiftsByCommId/', qry)
      .then(response => {
        this.shifts = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.shifts = []
      })
    },
    prepareCreate () {
      if (!this.curComm) {
        this.msg('Please choose a community to proceed', 2)
      } else {
        this.lShift = {
          comm_id: this.curComm.comm_id,
          shift_abbr: '',
          shift_hours: '',
          start_time: '',
          end_time: ''
        }
        this.lAction = 'create-shift'
      }
    },
    prepareUpdateShift (curShift) {
      this.lShift = Object.assign({}, curShift)
      this.lAction = 'update-shift'
    },
    saveChangesShift (action) {
      // validate and save Changes
      if (action === 'create-shift' || action === 'update-shift') {
        if (!this.$refs.sForm.validate()) {
          return
        }
      }
      this.beingSaved = true
      this.axios.post(config.SMARTILITY_API_URL + '/shift/' + action, this.lShift)
      .then(response => {
        this.loadShifts()
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    deleteShift () {
      // confirm
      if (confirm('Sure, you want to delete the shift "' + this.lShift.shift_abbr + '"?')) {
        // delete
        this.saveChangesShift('delete-shift')
      }
    },
    cancelChanges () {
      this.lAction = 'view'
    }
  }
}
</script>
